import React from "react";
import { Route, Switch } from "react-router-dom";
import {
  Logout,
  AccessDenied,
  MissingMultiFactor,
  Retry,
  NoUserProfileData,
  BaseApp,
  RetryKombit
} from "idc-ui-react";
// Our modules
import Layout from "./containers/Layout";
import { store as Main } from "./stores/Main";
// Styles
import "./App.css";

const App = () => (
  <BaseApp Stores={[Main]}>
    <Switch>
      <Route path="/logout" exact component={Logout} />
      <Route path="/access-denied" exact component={AccessDenied} />
      <Route
        path="/missing-multi-factor"
        exact
        component={MissingMultiFactor}
      />
      <Route path="/retry" exact component={Retry} />
      <Route path="/retry-kombit" exact component={RetryKombit} />
      <Route path="/no-user-data" exact component={NoUserProfileData} />
      <Route path="/:page?/:category?/:action?/:id?" component={Layout} />
    </Switch>
  </BaseApp>
);

export default App;
